export default __webpack_public_path__ + "static/media/clock.25ae2509.svg";